import * as rxjs from 'rxjs';
import * as rxjsOperators from 'rxjs/operators';
import * as ngCore from '@angular/core';
import * as ngCommon from '@angular/common';
import * as ngCommonHttp from '@angular/common/http';
import * as ngCompiler from '@angular/compiler';
import * as ngAnimations from '@angular/animations';
import * as ngAnimationsBrowser from '@angular/animations/browser';
import * as ngPlatformBrowser from '@angular/platform-browser';
import * as ngPlatformBrowserAnimations from '@angular/platform-browser/animations';
import * as ngPlatformBrowserDynamic from '@angular/platform-browser-dynamic';
import * as ngRouter from '@angular/router';
import * as ngForms from '@angular/forms';
import * as singleSpa from 'single-spa';
import * as vmwNgxVip from '@velocloud/angular-g11n-client';
import * as singleSpaAngularInternals from 'single-spa-angular/internals';
import * as singleSpaAngular from 'single-spa-angular';
import * as clrAngular from '@clr/angular';
import * as vcoPrebuilt from '@velocloud/angular-vco-prebuilt';
// eslint-disable-next-line import/no-extraneous-dependencies
import '@webcomponents/custom-elements/custom-elements.min.js';
import '@clr/icons/clr-icons.min.css';
import '@clr/icons/clr-icons.min.js';

declare global {
   interface Window {
      [key: string]: any;
   }
}

// Rxjs
window.rxjs = rxjs;
window.rxjs.operators = rxjsOperators;
// Angular Libraries
window.ng = {};
window.ng.core = ngCore;
window.ng.common = ngCommon;
window.ng.common.http = ngCommonHttp;
window.ng.compiler = ngCompiler;
window.ng.animations = ngAnimations;
window.ng.animations.browser = ngAnimationsBrowser;
window.ng.platformBrowser = ngPlatformBrowser;
window.ng.platformBrowser.animations = ngPlatformBrowserAnimations;
window.ng.platformBrowserDynamic = ngPlatformBrowserDynamic;
window.ng.router = ngRouter;
window.ng.forms = ngForms;
// VMW Ngx
window.vmw = {};
window.vmw['ngx-vip'] = vmwNgxVip;
// SingleSpa
window.singleSpa = singleSpa;
window['single-spa-angular-internals'] = singleSpaAngularInternals;
window['single-spa-angular'] = singleSpaAngular;
// Clarity
window.clr = {};
window.clr.angular = clrAngular;
// Velocloud
window.velocloud = {};
window.velocloud['angular-vco-prebuilt'] = vcoPrebuilt;
